export const projects = [
	{
		title: "Salvi - BPO Financeiro",
		description:
			"Um site institucional para uma empresa de serviços de BPO financeiro.",
		tags: ["bootstrap", "javascript"],
		url: "https://www.salvibpofinanceiro.com/",
		image: "/assets/salvi.png",
	},
	{
		title: "SROCHA.OS",
		description:
			"Meu portfólio pessoal, com um tema retrô de sistema operacional.",
		tags: ["react", "react-icons", "typescript"],
		url: "https://www.srocha.dev/",
		repo: "https://www.srocha.dev/",
		image: "/assets/srocha.png",
	},
	{
		title: "Orçamento Grátis",
		description:
			"Sistema gratuito para criação de orçamentos online. Crie orçamentos profissionais de forma rápida e eficiente.",
		tags: ["react", "tailwindcss", "axios"],
		url: "https://orcamentogratis.com.br/",
		repo: "https://github.com/srclayton/orcamento-gratis",
		image: "/assets/orcamentogratis.png",
	},
	{
		title: "Encurtai - Frontend",
		description:
			"Frontend para o encurtador de links Encurtai, com uma interface moderna e responsiva.",
		tags: ["vite", "react", "axios", "lucide-react", "typescript"],
		url: "https://www.encurtai.srocha.dev/",
		repo: "https://github.com/srclayton/encurtai-frontend",
		image: "/assets/encurtai.png",
	},
	{
		title: "Encurtai - Backend",
		description:
			"Backend para o encurtador de links Encurtai, com uma API RESTful.",
		tags: ["fastify", "jwt", "prisma", "typescript"],
		url: "https://www.encurtai.srocha.dev/",
		repo: "https://github.com/srclayton/encurtai-backend",
		image: "/assets/encurtai.png",
	},
	{
		title: "Validador de cartão de crédito.",
		description:
			"Um validador de cartão de crédito que usa o algoritmo de Luhn para validar o número do cartão.",
		tags: ["c", "python"],
		repo: "https://github.com/srclayton/Validador-de-cartao-de-credito",
		image: "/assets/validador-de-cartao.png",
	},
	{
		title: "Fake Data API",
		description:
			"Uma api de dados falsos para projetos que precisam de dados fictícios.",
		tags: ["fastify", "jwt", "mongodb", "typescript"],
		url: "https://srocha.vercel.app/static/index.html",
		repo: "https://github.com/srclayton/fake_data_api",
		image: "/assets/fake-data-api.png",
	},
	{
		title: "Telegram - Bot Rastreamento",
		description: "Um bot para rastreamento de entregas de encomendas.",
		tags: ["flask", "telegram-api", "mongodb", "python"],
		url: "https://github.com/srclayton/Rastreio",
		repo: "https://github.com/srclayton/Rastreio",
	},
	{
		title: "Quack Fire",
		description:
			"Um jogo de tiro disputado por duas pessoas, onde o objetivo é atingir o maior número de alvos.",
		tags: ["java", "javafx"],
		url: "https://github.com/srclayton/QuackFire",
		repo: "https://github.com/srclayton/QuackFire",
		image: "/assets/quack-fire.png",
	},
	{
		title: "Jogo da memoria",
		description:
			"Um jogo de memória com um tema do jogo Tom Clancy's Rainbow Six Siege.",
		tags: ["html", "css", "javascript"],
		url: "https://srclayton.github.io/jogo-da-memoria-2019/",
		repo: "https://github.com/srclayton/jogo-da-memoria-2019",
		image: "/assets/jogo-da-memoria.png",
	},
	{
		title: "Kimi Store",
		description: "Um site para uma loja de roupas.",
		tags: ["html", "css", "bootstrap"],
		url: "https://srclayton.github.io/Kimi-Store/produtos.html",
		repo: "https://github.com/srclayton/Kimi-Store",
		image: "/assets/kimi-store.png",
	},
	{
		title: "Cofre de senhas",
		description: "Um cofre de senhas mobile.",
		tags: ["java", "javafx"],
		repo: "https://github.com/srclayton/CSM43---Aplicativo-para-gerenciamento-de-senhas",
	},
];

export const allTags = projects.map((project) => project.tags).flat();
export const tags = [...new Set(allTags)];
